import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import './AffiliateBanner.css';

/**
 * Componente para exibir banners de afiliados
 * @param {Object} props - Propriedades do componente
 * @param {string} props.imageUrl - URL da imagem do banner (opcional)
 * @param {string} props.link - Link de destino do afiliado
 * @param {string} props.title - Título do banner
 * @param {string} props.description - Descrição curta
 * @param {string} props.buttonText - Texto do botão CTA
 * @param {string} props.type - Tipo de banner (investment, education, tool)
 * @param {string} props.position - Posição do banner (sidebar, content, results)
 * @param {string} props.customTheme - Tema específico de cores (opcional, overrides o tema do contexto)
 */
const AffiliateBanner = ({
  imageUrl,
  link,
  title,
  description,
  buttonText = "Saiba mais",
  type = "investment",
  position = "content",
  customTheme
}) => {
  // Obtém o tema atual do contexto
  const { theme: contextTheme } = useTheme();
  
  // Usa o customTheme se estiver definido, caso contrário usa o tema do contexto
  const currentTheme = customTheme || contextTheme;
  
  // Rastreamento de cliques para analytics (posteriormente poderia integrar com GA4)
  const handleClick = () => {
    // Função para rastrear cliques
    console.log(`Affiliate banner clicked: ${title}`);
    
    // Implementação futura: adicionar código de rastreamento de conversão
    // trackAffiliateClick(title, type);
  };
  
  // Determinar classe CSS com base no tipo, posição e tema atual
  const bannerClass = `affiliate-banner ${position} ${type} theme-${currentTheme}`;
  
  return (
    <div className={bannerClass}>
      {imageUrl && (
        <div className="banner-image">
          <img src={imageUrl} alt={title} loading="lazy" />
        </div>
      )}
      <div className="banner-content">
        <h4 className="banner-title">{title}</h4>
        <p className="banner-description">{description}</p>
        <a 
          href={link} 
          className="banner-button" 
          target="_blank" 
          rel="noopener noreferrer sponsored"
          onClick={handleClick}
        >
          {buttonText}
        </a>
      </div>
      <div className="banner-badge">
        <span className="badge-text">Recomendado</span>
      </div>
    </div>
  );
};

export default AffiliateBanner;
